import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerDataResponse, GeneralAction } from '@models/models';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { MessageService } from '@services/helpers/message-service/message.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {
	CompanySettingsList,
	GlobalSettingsList
} from '@services/settings/settings-overview/settings-overview-item-list';
import {
	SettingsOverview,
	SettingsOverviewListItem
} from '@models/brands.model';

@Injectable()
export class SettingsOverviewDataProvider {
	settingsOverviewSubject: BehaviorSubject<
		SettingsOverview
	> = new BehaviorSubject<SettingsOverview>({
		companySettings: null,
		globalSettings: null,
		actions: {}
	});

	constructor(
		private http: HttpClient,
		private messageService: MessageService
	) {}

	getSettingsOverviewItems(): Observable<SettingsOverview> {
		const url = '/api/user/v1/brand/settings';

		return this.http
			.get(url)
			.catch(error => {
				this.messageService.showToaster('e_0', 'general', error.error);
				return Observable.throw(error);
			})
			.pipe(
				map((res: ServerDataResponse<any>): any => res.data),
				map(data => {
					const companySettings = JSON.parse(
						JSON.stringify(data.brandSettings[0].settings)
					);

					const globalSettings = JSON.parse(
						JSON.stringify(data.brandSettings[1].settings)
					);

					this.settingsOverviewSubject.next({
						companySettings: this.createSettingsList(
							CompanySettingsList,
							companySettings
						),
						globalSettings: this.createSettingsList(
							GlobalSettingsList,
							globalSettings
						),
						brandName: data.brandSettings[0].brand,
						actions: data.brandSettings[0].actions,
						currentCompanyId: data.brandSettings[0].companyId,
						logoUrl: data.brandSettings[0].logoUrl
					});

					return data;
				})
			);
	}

	createSettingsList(
		settingsList: Array<SettingsOverviewListItem>,
		settingsListFromRequest: Array<GeneralAction>
	): Array<SettingsOverviewListItem> {
		const brandSettingsItems = [];

		settingsList.forEach((actionItem: SettingsOverviewListItem) => {
			Object.keys(settingsListFromRequest).forEach((item: string) => {
				if (item === actionItem.name) {
					const settingsItem = JSON.parse(JSON.stringify(actionItem));

					settingsItem.actionName = settingsListFromRequest[item].actionName;
					settingsItem.companySettingsType =
						settingsListFromRequest[item].companySettingsType;

					settingsItem.actionDescription =
						settingsListFromRequest[item].actionDescription;

					brandSettingsItems.push(settingsItem);
				}
			});
		});

		return brandSettingsItems;
	}

	settingsOverview(): Observable<SettingsOverview> {
		return this.settingsOverviewSubject.asObservable();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/settings/settings-overview/settings-overview.data.service.ts